<template>
  <div class="page_win userInfoMask">
    <div class="topContent">
      <div class="topContent_l">
        <!-- <img :src="logo2" alt="" /> -->
        <span>账号:{{ userInfo.uname }}</span>
      </div>

      <div class="closeBtn">
        <img :src="close_icon" class="closeImg" @click="close" />
      </div>
    </div>
    <div class="bottomContent">
      <div class="bottomContent_item" @click="getClick('IsAlertPwdFun')">
        <img :src="xiugai" alt="" />
        <span>修改密码</span>
      </div>
      <div class="bottomContent_item" @click="getClick('IsBindPhoneFun')">
        <img :src="bangding" alt="" />
        <span>绑定手机</span>
      </div>
      <div class="bottomContent_item" @click="getClick('IsLoginBoxFun')">
        <img :src="qiehuan" alt="" />
        <span>切换账号</span>
      </div>

      <div class="bottomContent_item" @click="toService" ref="btn">
        <img :src="kefu" alt="" />
        <span>客服</span>
      </div>
      <div class="bottomContent_item" @click="getClick('IsReconiseInfoFun')">
        <img :src="shiming" alt="" />
        <span>实名认证</span>
      </div>

      <div
        class="bottomContent_item"
        @click="getClick('IsCouponInfoFun')"
        v-if="showInfo.isCoupon == 0 || showInfo.isCoupon == '0'"
      >
        <img :src="youhuijuan" alt="" />
        <span>我的优惠卷</span>
      </div>
      <div class="bottomContent_item" @click="closeGame" v-else>
        <img :src="tuichu" alt="" />
        <span>账号注销</span>
      </div>
    </div>
    <div class="bottomMsg">
      <span
        >{{showInfo.indexPageTips}}</span
      >
    </div>
  </div>
</template>

<script>
import fun from "@/common/js/common.js";
import wx from "weixin-js-sdk";

export default {
  name: "userInfoMask",
  inject: ["reload", "innerToService"], //注入App里的reload方法
  data() {
    return {
      showInfo: { isCoupon: 1 },
      gameCustomerList: null,
      gameInfoDate: null,
      appid: "",
      agentId: "",
      adid: "",
      userInfo: {},
      showType: "vertical",
      close_icon: require("../../assets/img/new2/close.png"),
      logo2: require("../../assets/img/view6/logo2.png"),
      // logo2: require("../../assets/img/view6/logo2_old.png"),
      logoImgBlank: require("../../assets/img/new/logo.png"), // logo白色底色
      accountImg: require("../../assets/img/ico-user.png"),
      idcardImg: require("../../assets/img/ico-idcard.png"), //实名认证图标
      kefuImg: require("../../assets/img/ico-service.png"),
      idcardImg: require("../../assets/img/ico-idcard.png"), //实名认证图标
      xiugai: require("../../assets/img/view6/xiugai.png"),
      bangding: require("../../assets/img/view6/bangding.png"),
      qiehuan: require("../../assets/img/view6/qiehuan.png"),
      kefu: require("../../assets/img/view6/kefu.png"),
      shiming: require("../../assets/img/view6/shiming.png"),
      youhuijuan: require("../../assets/img/view6/youhuijuan.png"),
      tuichu: require("../../assets/img/view8/tuichu.png"),
    };
  },
  created() {
    this.showInfo = JSON.parse(localStorage.getItem("showInfo"));
  },
  mounted() {
    this.gameInfoDate =
      localStorage.getItem("gameInfoDate") &&
      localStorage.getItem("gameInfoDate") != "undefined"
        ? JSON.parse(localStorage.getItem("gameInfoDate"))
        : {};
    // var _this = this;
    this.userInfo =
      localStorage.getItem("userInfo") &&
      localStorage.getItem("userInfo") != "undefined"
        ? JSON.parse(localStorage.getItem("userInfo"))
        : {};
    this.appid = localStorage.getItem("appid")
      ? localStorage.getItem("appid")
      : "";
    this.adid = localStorage.getItem("adid")
      ? localStorage.getItem("adid")
      : fun.getQueryString("adid");
    this.agentId = localStorage.getItem("agentId")
      ? localStorage.getItem("agentId")
      : "";
    this.gameData = localStorage.getItem("gameData")
      ? localStorage.getItem("gameData")
      : "";
    this.gameCurrency = this.$store.state.gameCurrency;

    this.showInfo = JSON.parse(localStorage.getItem("showInfo"));
    this.gameCustomerList = this.showInfo.gameCustomerList;
  },
  methods: {
    // 开启客服弹窗
    toService() {
      this.innerToService();
    },
    //返回
    close() {
      this.$store.dispatch("IsUserInfoMaskFun", false);
    },
    getClick(type) {
      if (type == "IsLoginBoxFun") {
        localStorage.removeItem("userInfo");

        if (window.location.href.indexOf("adid") === -1) {
          this.adid = localStorage.getItem("adid")
            ? localStorage.getItem("adid")
            : "102000";
          window.location.href =
            (window.location.href.indexOf("?") === -1
              ? window.location.href
              : window.location.href.split("?")[0]) +
            "?adid=" +
            this.adid;
          localStorage.setItem("adid", this.adid);
        } else {
          this.adid = fun.getQueryString("adid");
          this.ref = fun.getQueryString("ref");
          localStorage.setItem("adid", fun.getQueryString("adid"));
          localStorage.setItem("ref", fun.getQueryString("ref"));
        }

        this.reload();
      } else if (type == "IsReconiseInfoFun") {
        if (this.userInfo.fcm == "1") {
          this.$toast.text("已认证");
        } else {
          this.$store.dispatch("IsUserInfoMaskFun", false);
          this.$store.dispatch(type, true);
        }
      } else if (type == "IsBindPhoneFun") {
        if (this.userInfo.bindPhone == "1") {
          this.$toast.text("已绑定手机号");
        } else {
          this.$store.dispatch("IsUserInfoMaskFun", false);
          this.$store.dispatch(type, true);
        }
      } else if (type == "IsAlertPwdFun") {
        if (this.userInfo.bindPhone == "0") {
          this.$toast.text("请绑定手机号");
        } else {
          this.$store.dispatch("IsUserInfoMaskFun", false);
          this.$store.dispatch(type, true);
        }
      } else {
        if (type == "IsCouponInfoFun") {
          this.$store.dispatch("IsCouponFromFun", "mask");
        }
        this.$store.dispatch("IsUserInfoMaskFun", false);
        this.$store.dispatch(type, true);
      }
    },
    closeGame() {
      this.$store.dispatch("IsUserInfoMaskFun", false);
      this.$store.dispatch("IsLogoutAccountFun", true);
    },
    CloseWebPage() {
      if (navigator.userAgent.indexOf("MSIE") > 0) {
        if (navigator.userAgent.indexOf("MSIE 6.0") > 0) {
          window.opener = null;
          window.close();
        } else {
          window.open("", "_top");
          window.top.close();
        }
      } else if (navigator.userAgent.indexOf("Firefox") > 0) {
        window.location.href = "about:blank "; //火狐默认状态非window.open的页面window.close是无效的
        //window.history.go(-2);
      } else {
        window.opener = null;
        window.open("", "_self", "");
        window.close();
      }
    },

    toAccount() {
      this.$store.dispatch("IsUserInfoMaskFun", false);
      this.$store.dispatch("IsAccountFun", true);
    },
    toReconiseIn() {
      if (this.userInfo.fcm == "1") {
        this.$toast.text("已实名认证");
      } else {
        this.$store.dispatch("IsUserInfoMaskFun", false);
        this.$store.dispatch("IsReconiseInfoFun", true);
      }
    },
    contck() {
      window.webkit.messageHandlers.initGameCall.postMessage({
        GameData: "https://url.cn/xxx?_type=wpa&qidian=true",
      });
    },
    // 退出登陆
    loginOut() {
      localStorage.removeItem("userInfo");
      localStorage.removeItem("isUploadUserInfo");
      this.$store.dispatch("IsUserInfoMaskFun", false);
      this.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin flex_box(
  $flex-direction: row,
  $justify-content: none,
  $align-items: none
) {
  display: flex;
  flex-direction: $flex-direction;
  justify-content: $justify-content;
  align-items: $align-items;
}
.topContent {
  height: 0.68rem;
  @include flex_box(row, space-between, stretch);
}
.topContent_l,
.closeBtn {
  @include flex_box(row, center, center);
}
.topContent_l img {
  width: 2rem;
  height: auto;
  margin-right: 0.14rem;
}
.closeBtn img {
  width: 0.3rem;
}
.bottomContent {
  display: flex;
  flex-wrap: wrap;
  padding: 0.18rem 0.3rem 0;
}
.bottomContent_item {
  margin: 0.3rem 0 0.2rem 0;
  width: 1.6rem;
  @include flex_box(column, none, center);
  img {
    width: 0.83rem;
    width: 0.83rem;
  }
  span {
    margin-top: 0.12rem;
    font-size: 0.22rem;
  }
}
.bottomMsg {
  margin-top: 0.1rem;
  font-size: 12px;
  @include flex_box(row, center, center);
  color: #fa1155;
  span {
    // text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/view8/userInfoMask.vue